import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "summary-choices" }
const _hoisted_2 = { class: "summary-choices__rows" }
const _hoisted_3 = { class: "summary-choices__row-body" }
const _hoisted_4 = { class: "summary-choices__row-title" }
const _hoisted_5 = { class: "summary-choices__row-desc" }

import type { SummaryRow } from '@/models/onboarding.types'


export default /*@__PURE__*/_defineComponent({
  __name: 'LearningSetupSummaryChoicesSection',
  props: {
    rows: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rows, (row, i) => {
        return (_openBlock(), _createElementBlock("li", {
          key: `row-${i}-${row.sectionLabel}`,
          class: "summary-choices__row"
        }, [
          _cache[1] || (_cache[1] = _createElementVNode("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createElementVNode("path", {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d: "M9.82125 3.72359C9.85132 3.51792 10.1486 3.51792 10.1787 3.72359C10.6392 6.881 13.1189 9.36077 16.2763 9.82125C16.482 9.85132 16.482 10.1486 16.2763 10.1787C13.1189 10.6392 10.6392 13.1189 10.1787 16.2763C10.1486 16.482 9.85132 16.482 9.82125 16.2763C9.36077 13.1189 6.881 10.6392 3.72359 10.1787C3.51792 10.1486 3.51792 9.85132 3.72359 9.82125C6.881 9.36077 9.36077 6.881 9.82125 3.72359Z",
              fill: "#3876F0",
              "fill-opacity": "0.5"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, [
              _createElementVNode("span", null, _toDisplayString(row.sectionLabel) + ": “" + _toDisplayString(row.quotedChoice) + "”", 1),
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "summary-choices__quote" }, null, -1))
            ]),
            _createElementVNode("p", _hoisted_5, _toDisplayString(row.benefitLine), 1)
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})